import { Component } from "@angular/core";
import { DatePicker } from "@ionic-native/date-picker";
import {
  NavController,
  ModalController,
  ToastController,
  LoadingController,
  NavParams,
  AlertController,
  ActionSheetController,
} from "ionic-angular";
import { BarcodeScanner } from "@ionic-native/barcode-scanner";
import { Camera, CameraOptions } from "@ionic-native/camera";
import { IonicSelectableComponent } from "ionic-selectable";

//*pages
import { LocationPage } from "../location/page";
import { ConditionPage } from "../condition/page";
import { ClassificationPage } from "../classification/page";
import { DepartmentPage, DetailImagePage, ProjectPage, SelectPage } from "../";

//*providers
import {
  Item,
  Api,
  Tracking,
  Master,
  Assignment,
} from "@providers/asset/index";

// import { Utility } from '@providers/resources/utility';

declare var cordova: any;

@Component({
  selector: "page-form_item",
  templateUrl: "page.html",
})
export class FormItemPage {
  item = {
    id                       : "",
    scm_asset_id             : "",
    asset_name               : "",
    asset_classification_id  : "",
    asset_classification_code: "",
    asset_classification_name: "",
    asset_location_id        : "",
    asset_location_name      : "",
    asset_old_code           : "",
    asset_old_code2          : "",
    asset_temp_code          : "",
    asset_new_code           : "",
    asset_new_code2          : "",
    asset_condition_id       : "",
    asset_condition_name     : "",
    location                 : "",
    status_location          : "Standby",
    estimated_value          : "",
    brand                    : "",
    brand_type               : "",
    no_seri                  : "",
    no_po                    : "",
    company_id               : "",
    company_name             : "",
    department_id            : "",
    department_name          : "",
    project_code             : "",
    project_title            : "",
    user_id                  : "",
    asset_user_name          : "",
    user_code                : "",
    user_code_dept           : "",
    user_dept_name           : "",
    pj_id                    : "",
    pj_nik                   : "",
    pj_name                  : "",
    last_opname              : "",
    vendor                   : "",
    acquisition_year         : 2017,
    calibration_expired      : null,
    item_amount              : 1,
    location_path_id         : "",
    related_to               : "",
    flag_perbaikan           : 0,
    flag_temuan              : 0,
    flag_modify              : 0,
    flag_penghapusan         : 0,
    flag_kalibrasi           : 0,
    notes                    : "",
    witness_by               : "",
    verify_by_dept           : 0,
    verify_by_department_name: "",
    assignment_id            : 0,
    item_validated           : 0,
  };

  form_perbaikan = {
    id               : "",
    type_perbaikan   : "",
    vendor_id        : "",
    vendor_name      : "",
    tanggal_perbaikan: "",
    keterangan       : "",
  };

  id_perbaikan    = 0;
  last_perbaikan  = {};
  f_perbaikan_old = false;
  f_perbaikan     = false;
  f_temuan        = false;
  f_modify        = false;
  f_penghapusan   = false;
  f_validated     = false;
  f_kalibrasi     = false;

  images      : any     = [];
  base_qr     : any     = "";
  url_img     : any     = "x";
               base_url = "";
  list_path   : any     = [];
  qr_code_data: any     = "";
  listCompany : any     = [];

  assign        = 0;
  assignment_id = 0;
  assign_type   = "";

  user_asset = "";
  asset_fasker_type = [
    { user_asset: "dept", asset_fasker_name: "Department" },
    { user_asset: "user", asset_fasker_name: "Karyawan" },
  ];

  item_tracking: any = "";

  vendors: any = [];
  vendor_selected = {
    short_name: "",
  };

  constructor(
    public  api           : Api,
    public  itemApi       : Item,
    public  trackingApi   : Tracking,
    public  masterApi     : Master,
    public  navCtrl       : NavController,
    public  modalCtrl     : ModalController,
    public  barcodeScanner: BarcodeScanner,
    public  camera        : Camera,
    public  toastCtrl     : ToastController,
    public  loadingCtrl   : LoadingController,
    private alertCtrl     : AlertController,
    public  actSheetCtrl  : ActionSheetController,
            navParams     : NavParams,
    public  assignmentApi : Assignment,
    private datePicker    : DatePicker
  ) {
    this.base_url = this.api.url;
    this.url_img = this.api.url + "/client/uploads/";

    if (navParams.get("location") != undefined) {
      let location = navParams.get("location");
      this.item.asset_location_id = location.id;
      this.item.asset_location_name = location.location_name;
      this.getPath(location.location_path_id);
    }

    if (navParams.get("assign") == 1) {
      this.assign = 1;
      this.assign_type = navParams.get("assign_type");
      this.assignment_id = navParams.get("assignment_id");
      this.item.assignment_id = this.assignment_id;
      if (navParams.get("assign_location") != undefined) {
        this.item.asset_location_id = navParams.get("assign_location");
        this.getPath(navParams.get("assign_location_path"));
      }
      if (navParams.get("project_code") != undefined) {
        this.item.project_code = navParams.get("project_code");
        this.item.project_title = navParams.get("project_title");
      }
    }

    if (navParams.get("id") != undefined) {
      this.item.id = navParams.get("id");
      this.getItemByID(this.item.id);
      this.getImagesByID();
    }
    if (this.trackingApi.active) {
      this.getItemTracking(this.item.id);
    }
    if (navParams.get("id_perbaikan") != undefined) {
      this.id_perbaikan = navParams.get("id_perbaikan");
      this.getPerbaikan();
    }

    this.getCompany();
    console.log("assign type => ", this.assign_type);

    //* to get vendor list
    this.getVendors();
  }

  presentToast(msg) {
    this.toastCtrl
      .create({
        message: msg,
        duration: 3000,
        position: "top",
      })
      .present();
  }

  pilihCondition() {
    let myModal = this.modalCtrl.create(ConditionPage, { pilih: 1 });
    myModal.onDidDismiss((data) => {
      if (data.item) {
        this.item.asset_condition_name = data.item.name;
        this.item.asset_condition_id = data.item.id;
      }
    });
    myModal.present();
  }

  getCompany() {
    let loading = this.loadingCtrl.create({
      content: "Please wait...",
    });
    loading.present();

    let params = {};
    this.masterApi.getCompany(params).subscribe(
      (resp: any) => {
        this.listCompany = resp.data;
        loading.dismiss();
      },
      (err) => {
        loading.dismiss();
      }
    );
  }

  pilihDepartment() {
    let myModal = this.modalCtrl.create(DepartmentPage, { pilih: 1 });
    myModal.onDidDismiss((data) => {
      if (data.item) {
        this.item.department_name = data.item.department_name;
        this.item.department_id = data.item.department_id;
      }
    });
    myModal.present();
  }

  pilihProject() {
    if (this.assignment_id == 0 || this.assign_type != "project") {
      let myModal = this.modalCtrl.create(ProjectPage, { pilih: 1 });
      myModal.onDidDismiss((data) => {
        if (data.item) {
          this.item.project_title = data.item.title;
          this.item.project_code = data.item.project_code;
        }
      });
      myModal.present();
    } else {
      this.presentToast("Yout can't change project");
    }
  }

  pilihLocation() {
    if (this.assignment_id == 0 || this.assign_type != "location") {
      let myModal = this.modalCtrl.create(LocationPage, { pilih: 1 });
      myModal.onDidDismiss((data) => {
        if (data.item) {
          this.item.asset_location_name = data.item.location_name;
          this.item.asset_location_id = data.item.id;
          this.getPath(data.item.location_path_id);
        }
      });
      myModal.present();
    } else {
      this.presentToast("You can't change location");
    }
  }

  pilihClassification() {
    let myModal = this.modalCtrl.create(ClassificationPage, { pilih: 1 });
    myModal.onDidDismiss((data) => {
      if (data.item) {
        this.item.asset_classification_name = data.item.classification_name;
        this.item.asset_classification_id = data.item.id;
        this.item.asset_classification_code = data.item.classification_code;
      }
    });
    myModal.present();
  }

  scan(field) {
    this.barcodeScanner
      .scan()
      .then((barcodeData) => {
        console.log("Barcode data", barcodeData);
        this.item[field] = barcodeData.text;
      })
      .catch((err) => {
        console.log("Error", err);
      });
  }

  ketik(idx) {
    let msg = "";
    msg = "Ketik Kode";
    let alert = this.alertCtrl.create({
      //title: 'Konfirmasi',
      subTitle: msg,
      inputs: [
        {
          name: "code",
          placeholder: "Kode",
        },
      ],
      buttons: [
        {
          text: "Cancel",
          role: "cancel",
          handler: (data) => {
            console.log("Cancel clicked");
          },
        },
        {
          text: "Done",
          handler: (data) => {
            this.item[idx] = data.code;
          },
        },
      ],
    });
    alert.present();
  }

  getItemByID(id) {
    let loading = this.loadingCtrl.create({
      content: "Please wait...",
    });
    loading.present();

    let params = { id: id };

    let get: any;
    if (this.assign > 0) {
      get = this.assignmentApi.getItem(params);
    } else {
      get = this.itemApi.get(params);
    }

    get.subscribe(
      (resp: any) => {
        if (resp.data.length > 0) {
          this.item = resp.data[0];
          this.getPath(this.item.location_path_id);
          this.qr_code_data = JSON.stringify(this.item);
        }

        if (this.item.flag_perbaikan == 1) {
          this.f_perbaikan = true;
          this.f_perbaikan_old = true;
        }
        if (this.item.flag_temuan == 1) {
          this.f_temuan = true;
        }
        if (this.item.flag_penghapusan == 1) {
          this.f_penghapusan = true;
        }
        if (this.item.flag_modify == 1) {
          this.f_modify = true;
        }
        if (this.item.item_validated == 1) {
          this.f_validated = true;
        }
        if (this.item.flag_kalibrasi == 1) {
          this.f_kalibrasi = true;
        }

        if (
          this.item.user_code != "0" &&
          this.item.user_code != "" &&
          this.item.user_code != "null"
        ) {
          this.user_asset = "user";
        }
        if (
          this.item.user_code_dept != "0" &&
          this.item.user_code_dept != "" &&
          this.item.user_code_dept != "null"
        ) {
          this.user_asset = "dept";
        }

        console.log("user asset => ", this.user_asset);
        loading.dismiss();
      },
      (err) => {
        loading.dismiss();
      }
    );
  }

  getItemTracking(id) {
    let params = { asset_id: id };
    this.trackingApi.get_tracked_item(params).subscribe((resp: any) => {
      if (resp.data != "") {
        this.item_tracking = resp.data[0];
      }
      console.log("tracking item => ", this.item_tracking);
    });
  }

  getImagesByID() {
    let loading = this.loadingCtrl.create({
      content: "Please wait...",
    });
    loading.present();

    let params: any = {
      asset_id: this.item.id,
    };
    let get: any;
    if (this.assign == 1) {
      get = this.assignmentApi.getImages(params);
    } else {
      get = this.itemApi.getImages(params);
    }
    get.subscribe(
      (resp: any) => {
        if (resp.data.length > 0) {
          this.images = resp.data;
        }
        loading.dismiss();
      },
      (err) => {
        loading.dismiss();
      }
    );
  }

  takePicture(camera = 1) {
    const options: CameraOptions = {
      quality: 25,
      destinationType: this.camera.DestinationType.DATA_URL,
      targetWidth: 1024,
      sourceType: camera,
    };

    this.camera.getPicture(options).then(
      (imageData) => {
        // imageData is either a base64 encoded string or a file URI
        // If it's base64 (DATA_URL):
        let base64Image = "data:image/jpeg;base64," + imageData;
        this.save_image(base64Image);
      },
      (err) => {
        // Handle error
      }
    );
  }

  viewImage(rec) {
    let profileModal = this.modalCtrl.create(DetailImagePage, {
      url_image: this.url_img + rec.generated_name,
      detail: rec,
      edit: true,
      assign: this.assign,
    });
    profileModal.present();
    console.log("Image params => ", rec);
  }

  resetAdd() {
    this.item.id = "";
    this.item.asset_name = "";
    this.item.asset_old_code = "";
    this.item.asset_temp_code = "";
    this.item.asset_new_code = "";
    this.item.estimated_value = "";
  }

  ubahFlagPerbaikan() {
    this.f_perbaikan = !this.f_perbaikan;
    if (this.f_perbaikan == true) {
      this.item.flag_perbaikan = 1;
    } else {
      this.item.flag_perbaikan = 0;
    }
    console.log("f_perbaikan => ", this.f_perbaikan);
    console.log("f_old_perbaikan => ", this.f_perbaikan_old);
  }
  ubahFlagTemuan() {
    this.f_temuan = !this.f_temuan;
    if (this.f_temuan == true) {
      this.item.flag_temuan = 1;
    } else {
      this.item.flag_temuan = 0;
    }
  }
  ubahFlagPenghapusan() {
    this.f_penghapusan = !this.f_penghapusan;
    if (this.f_penghapusan == true) {
      this.item.flag_penghapusan = 1;
    } else {
      this.item.flag_penghapusan = 0;
    }
  }
  ubahFlagModify() {
    this.f_modify = !this.f_modify;
    if (this.f_modify == true) {
      this.item.flag_modify = 1;
    } else {
      this.item.flag_modify = 0;
    }
  }
  ubahFlagKalibrasi() {
    this.f_kalibrasi = !this.f_kalibrasi;
    if (this.f_kalibrasi == true) {
      this.item.flag_kalibrasi = 1;
    } else {
      this.item.flag_kalibrasi = 0;
    }
  }
  ubahFlagValidated() {
    this.f_validated = !this.f_validated;
    if (this.f_validated == true) {
      this.item.item_validated = 1;
    } else {
      this.item.item_validated = 0;
    }
  }

  simpan() {
    if (this.item.asset_name == "" || this.item.asset_name == null) {
      this.presentToast("Gagal simpan, Asset Name tidak boleh kosong.");
      return;
    }
    if (
      this.item.asset_classification_id == "" ||
      this.item.asset_classification_id == "0" ||
      this.item.asset_classification_id == null
    ) {
      this.presentToast("Gagal simpan, Klasifikasi tidak boleh kosong.");
      return;
    }
    if (
      this.item.asset_location_id == "" ||
      this.item.asset_location_id == "0" ||
      this.item.asset_location_id == null
    ) {
      this.presentToast("Gagal simpan, Lokasi tidak boleh kosong.");
      return;
    }
    if (
      this.item.company_id == "" ||
      this.item.company_id == null ||
      this.item.company_id == "0"
    ) {
      this.presentToast("Gagal simpan, Company tidak boleh kosong.");
      return;
    }
    if (this.item.acquisition_year == 0) {
      this.presentToast("Gagal simpan, Acquisition Year tidak boleh kosong.");
      return;
    }
    if (
      this.item.department_id == "" ||
      this.item.department_id == "0" ||
      this.item.department_id == null
    ) {
      this.presentToast("Gagal simpan, Dept/cabang tidak boleh kosong.");
      return;
    }
    if (this.item.flag_perbaikan == 1) {
      if (this.form_perbaikan.tanggal_perbaikan == "") {
        this.presentToast("Lengkapi data tanggal perbaikan !");
        return;
      }
      if (this.form_perbaikan.type_perbaikan == "") {
        this.presentToast("Lengkapi data type perbaikan !");
        return;
      }
      if (
        this.form_perbaikan.type_perbaikan == "Vendor" &&
        this.form_perbaikan.vendor_id == ""
      ) {
        this.presentToast("Lengkapi data vendor perbaikan !");
        return;
      }
      if (this.form_perbaikan.keterangan == "") {
        this.presentToast("Lengkapi data keterangan perbaikan");
        return;
      }
    }
    if (this.item.asset_name == "") {
      this.item.asset_name = this.item.asset_classification_name;
    }
    if (this.assign == 1) {
      this.item.assignment_id = this.assignment_id;
    }
    if (!isNaN(Number(this.item.company_id))) {
      var comp_id = Number(this.item.company_id);
      if (comp_id > 90 && this.item.vendor == "") {
        this.presentToast("Lengkapi data vendor");
        return;
      }
    }

    let loading = this.loadingCtrl.create({
      content: "Please wait...",
    });
    loading.present();

    let params: any = this.item;

    params.dokument_id = "";
    let dok_arr = [];
    this.images.forEach((el) => {
      if (el.asset_id == undefined) {
        dok_arr.push(el.dokument_id);
      }
    });
    params.dokument_id = dok_arr.join(",");
    params.scm_asset_id = this.item.id;
    console.log(params);
    if (this.assign == 1) {
      this.assignmentApi.saveResult(params).subscribe(
        (resp: any) => {
          this.item.asset_new_code = resp.data.asset_new_code;
          let data: any = {
            location_id: params.asset_location_id,
            project_code: params.project_code,
            asset_item_id: resp.data.id,
            assignment_id: this.assignment_id,
          };
          if (params.id == "") {
            data.act = "new";
          } else {
            data.act = "modify";
          }

          this.assign_item(data);
          if (params.id == "") {
            this.item.id = resp.data.id;
            this.getItemTracking(resp.data.id);
            this.getItemByID(resp.data.id);
            this.getImagesByID();
          } else {
            this.navCtrl.pop();
          }
          loading.dismiss();
          this.presentToast(resp.msg);
        },
        (err) => {
          loading.dismiss();
        }
      );
    } else {
      this.itemApi.save(params).subscribe(
        (resp: any) => {
          if (this.trackingApi.active) {
            let data: any = {
              location_id: params.location_id,
              asset_item_id: resp.data.id,
            };
            if (params.id == "") {
              data.act = "new";
            } else {
              if (this.item_tracking.act == "new") {
              } else {
                data.act = "modify";
              }
            }
            if (this.item_tracking != "") {
              data.id = this.item_tracking.id;
            }
            this.track_item(data);
          }
          if (params.id == "") {
            this.item.id = resp.data.id;
            this.getItemTracking(resp.data.id);
            this.getItemByID(resp.data.id);
            this.getImagesByID();
          } else {
            this.navCtrl.pop();
          }

          if (this.item.flag_perbaikan == 1) {
            this.savePerbaikan();
          }

          console.log("resp => ", resp);
          loading.dismiss();
          this.presentToast(resp.msg);
        },
        (err) => {
          loading.dismiss();
        }
      );
    }
  }

  track_item(params) {
    let loading = this.loadingCtrl.create({
      content: "Please wait...",
    });
    loading.present();

    this.trackingApi.post_item(params).subscribe(
      (resp: any) => {
        loading.dismiss();
      },
      (err) => {
        loading.dismiss();
      }
    );
  }

  assign_item(params) {
    let loading = this.loadingCtrl.create({
      content: "Please wait...",
    });
    loading.present();

    this.assignmentApi.saveTrackAssign(params).subscribe(
      (resp: any) => {
        loading.dismiss();
      },
      (err) => {
        loading.dismiss();
      }
    );
  }

  save_image(img) {
    let loading = this.loadingCtrl.create({
      content: "Please wait...",
    });
    loading.present();

    let params = { img: img };
    this.itemApi.save_image(params).subscribe(
      (resp: any) => {
        resp.data.dokument_id = resp.data.id;
        resp.data.id = "";
        this.images.push(resp.data);
        loading.dismiss();
      },
      (err) => {
        loading.dismiss();
      }
    );
  }

  getPath(location_path) {
    let loading = this.loadingCtrl.create({
      content: "Please wait...",
    });
    loading.present();

    let params = { location_path: location_path };

    this.masterApi.getLocation(params).subscribe(
      (resp: any) => {
        if (resp.data.length > 0) {
          this.list_path = resp.data;
        } else {
        }
        loading.dismiss();
      },
      (err) => {
        loading.dismiss();
      }
    );
  }

  printType() {
    const actionSheet = this.actSheetCtrl.create({
      title: "Printer Type",
      buttons: [
        {
          text: "Wi-Fi",
          icon: "wifi",
          handler: () => {
            console.log("Print Via Wifi");
            this.getPrinters("wifi");
          },
        },
        {
          text: "Bluetooth",
          icon: "bluetooth",
          cssClass: "BluetoothIcon",
          handler: () => {
            console.log("Print Via Bluetooth");
            this.getPrinters("bluetooth");
          },
        },
      ],
    });
    actionSheet.present();
  }

  getPrinters(type) {
    let loading = this.loadingCtrl.create({
      content: "Please wait...",
    });
    loading.present();

    let params: any = {
      t: this.item.asset_new_code,
      t_: this.item.asset_new_code2,
      t2: this.item.asset_old_code2,
      sn: this.item.no_seri,
      s: 0,
    };

    let find: any;
    if (type == "wifi") {
      find = cordova.plugins.brotherPrinter.findNetworkPrinters;
    } else {
      find = cordova.plugins.brotherPrinter.findBluetoothPrinters;
    }
    this.masterApi.getBaseQR(params).subscribe(
      (resp: any) => {
        var that = this;
        this.base_qr = resp.image_data_base64;
        find(
          function (printers) {
            if (printers.length > 0) {
              console.log("printers found => ", printers);
              // if(printers.length==1){
              //   this.print(printers[0]);
              // }else{
              loading.dismiss();
              const printerActSheet = that.actSheetCtrl.create({
                title: "Pilih Printer",
              });
              for (let i = 0; i < printers.length; i++) {
                var button = {
                  text: printers[i].model + " - " + printers[i].nodeName,
                  icon: "print",
                  handler: () => {
                    console.log("printer used => ", printers[i]);
                    that.print(printers[i]);
                  },
                };
                printerActSheet.addButton(button);
              }
              printerActSheet.present();
              // }
            } else {
              alert("Printer Not Found !");
              loading.dismiss();
            }
          },
          function (err) {
            console.log(err);
            loading.dismiss();
          }
        );
      },
      (err) => {
        console.log(err);
        loading.dismiss();
      }
    );
  }

  print(printer) {
    let loading = this.loadingCtrl.create({
      content: "Please wait...",
    });
    loading.present();

    let that = this;

    cordova.plugins.brotherPrinter.setPrinter(
      printer,
      function () {
        cordova.plugins.brotherPrinter.printViaSDK(
          that.base_qr,
          function (statusCode) {
            console.log(statusCode);
            if (statusCode.result) {
              that.presentToast(statusCode.result);
            }
            loading.dismiss();
          },
          function (err) {
            console.log(err);
            loading.dismiss();
          }
        );
      },
      function (err) {
        console.log(err);
        loading.dismiss();
      }
    );
  }

  pilihUser() {
    let myModal = this.modalCtrl.create(SelectPage, {
      pilihModal: 3,
      selectMod: 3,
      assigne: 0,
    });
    myModal.onDidDismiss((data) => {
      if (data.item != "") {
        this.item.asset_user_name = data.item.user_name;
        this.item.user_code = data.item.user_nik;
        this.item.user_dept_name = "";
        this.item.user_code_dept = "0";
        this.item.pj_name = "";
        this.item.pj_id = "0";
        this.item.pj_nik = "";
        console.log("user_code_dept => ", this.item.user_code_dept);
      }
    });
    myModal.present();
  }
  pilihUserDept() {
    let myModal = this.modalCtrl.create(DepartmentPage, { pilih: 1 });
    myModal.onDidDismiss((data) => {
      if (data.item) {
        this.item.user_dept_name = data.item.department_name;
        this.item.user_code_dept = data.item.department_id;
        this.item.asset_user_name = "";
        this.item.user_code = "0";
        console.log("user_code => ", this.item.user_code);
      }
    });
    myModal.present();
  }
  pilihPJ() {
    let myModal = this.modalCtrl.create(SelectPage, {
      pilihModal: 3,
      selectMod: 3,
      assigne: 0,
    });
    myModal.onDidDismiss((data) => {
      if (data.item != "") {
        this.item.pj_name = data.item.user_name;
        this.item.pj_id = data.item.id;
        this.item.pj_nik = data.item.user_nik;
        this.item.asset_user_name = "";
        this.item.user_code = "0";
      }
    });
    myModal.present();
  }

  selectWitness() {
    let myModal = this.modalCtrl.create(SelectPage, {
      pilihModal: 3,
      selectMod: 3,
      assigne: 0,
    });
    myModal.onDidDismiss((data) => {
      if (data.item != "") {
        this.item.witness_by = data.item.user_name;
      }
    });
    myModal.present();
  }

  selectVerifyDept() {
    let myModal = this.modalCtrl.create(DepartmentPage, {
      pilih: 1,
      sourceDept: "ops",
    });
    myModal.onDidDismiss((data) => {
      if (data.item != "") {
        this.item.verify_by_department_name = data.item.department_name;
        this.item.verify_by_dept = data.item.department_id;
      }
    });
    myModal.present();
  }

  selectCalibrationExpired() {
    this.datePicker
      .show({
        date: new Date(),
        mode: "date",
        // minDate     : new Date().valueOf(),
        androidTheme: this.datePicker.ANDROID_THEMES.THEME_DEVICE_DEFAULT_LIGHT,
      })
      .then(
        (date) =>
          (this.item.calibration_expired = new Date(
            date.getTime() - date.getTimezoneOffset() * 60000
          ).toISOString()),
        (err) => console.log("ERROR : " + err)
      );
  }

  pilihTanggalPerbaikan() {
    this.datePicker
      .show({
        date: new Date(),
        mode: "date",
        // minDate: new Date().valueOf(),
        androidTheme: this.datePicker.ANDROID_THEMES.THEME_DEVICE_DEFAULT_LIGHT,
      })
      .then(
        (date) =>
          (this.form_perbaikan.tanggal_perbaikan = new Date(
            date.getTime() - date.getTimezoneOffset() * 60000
          ).toISOString()),
        (err) => console.log("ERROR : " + err)
      );
  }

  pilihVendorPerbaikan() {
    let myModal = this.modalCtrl.create(SelectPage, {
      pilihModal: 4,
      selectMod: 4,
      assigne: 0,
    });
    myModal.onDidDismiss((data) => {
      if (data.item != "") {
        this.form_perbaikan.vendor_name = data.item.vendor_name;
        this.form_perbaikan.vendor_id = data.item.id;
      }
    });
    myModal.present();
  }

  getPerbaikan() {
    let params: any = {
      asset_id: this.item.id,
    };
    if (this.id_perbaikan > 0) {
      params.id = this.id_perbaikan;
    }
    this.itemApi.getPerbaikan(params).subscribe((resp: any) => {
      if (resp.data) {
        this.form_perbaikan = resp.data;
      }
    });
  }

  savePerbaikan() {
    let params: any = this.form_perbaikan;
    params.asset_id = this.item.id;
    if (this.f_perbaikan_old && !this.f_perbaikan) {
      params.valid_sts = 0;
    } else {
      params.valid_sts = 1;
    }
    this.itemApi.savePerbaikan(params).subscribe(
      (resp: any) => {
        console.log("resp savePerbaikan => ", resp);
      },
      (err) => {
        console.log("err savePerbaikan => ", err);
      }
    );
  }

  vendorChange(event: { component: IonicSelectableComponent; value: any }) {
    this.item.vendor = this.vendor_selected.short_name;
    console.log("vendor selected:", this.item.vendor);
  }

  getVendors() {
    let params = {};
    this.masterApi.getMasterVendor().subscribe((resp: any) => {
      if (resp.success) {
        this.vendors = resp.data;
        console.log("vendors data = ", resp.data);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/asset/form_item/page.ts